module.exports = __webpack_public_path__ + "static/media/jayce.2dc77131.png";